import React, { useState, useEffect, useContext } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import ToggleButton from '@material-ui/lab/ToggleButton';
import Tooltip from '@material-ui/core/Tooltip';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';

import Radio from '@material-ui/core/Radio';
import { green, red, blue, purple, indigo, grey } from '@material-ui/core/colors';

import { SessionContext } from "../context/session-context";


const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}))(Tooltip);

const RedRadio = withStyles({
  root: {
    color: red[400],
    '&$checked': {
      color: red[600],
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);

const IndigoRadio = withStyles({
  root: {
    color: indigo[400],
    '&$checked': {
      color: indigo[600],
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);

const GreenRadio = withStyles({
  root: {
    color: green[400],
    '&$checked': {
      color: green[600],
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);

const PurpleRadio = withStyles({
  root: {
    color: purple[400],
    '&$checked': {
      color: purple[600],
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);

const BlackRadio = withStyles({
  root: {
    color: grey[800],
    '&$checked': {
      color: grey[900],
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);

export default function DataToolsPaper(props) {

  const useStyles = makeStyles((theme) => ({
      paper:{
          height: 82,
      },
      containerLabel:{
        marginTop:5,
        color:'#000',
        marginBottom:10,
      },
      containerHeader:{
        marginTop:5,
        marginLeft:20,
        color:'#000',
        marginBottom:10,
      },
      divider:{
        marginTop:10,
        marginBottom:10,
        marginLeft:0,
        marginRight:0,
      },

      textField: {
        minWidth: 140,
        marginTop:10,
      },
      textItemFont:{
        fontSize:11
      },
      properties:{
        padding:10,
      },
      propertiesItem:{
        padding:5,
        border: '1px solid #666',
      },
      propertiesLabel:{
        color:'#000',
      }

}));

  const classes = useStyles(props);
  const [sState, sDispatch] = useContext(SessionContext);

  const [fillStyle, setFillStyle] = useState(''); //Red
  const [fillColor, setFillColor] = useState(''); //Red
  const [fillTransparancy, setFillTransparancy] = useState(0); //Red
  
  const [selectedTool, setSelectedTool] = useState('select');

  const handleFillStyleChange = (event) => {
    setFillColor(event.target.value);
  };


useEffect(() => {
    const fillhex = rgbStringToHex(sState.annotationStyle.fill.colour);
    setFillColor(fillhex);
},[]);

useEffect(() => {
if (props.activetool === 'select' && fillStyle !== sState.annotationStyle.fill.colour){
    
    let fillColour = sState.annotationStyle.fill.colour;
    setFillStyle(fillColour);
    console.log("returned fill colour. "+fillColour);
    
    const fillhex = rgbStringToHex(fillColour);
    setFillColor(fillhex);
  }
},[sState.annotationStyle.fill.colour]);


  /**
   * Stores changes to outlinestyle
   */
  useEffect(() => {

    if (fillColor !== ''){
        const s = sState.annotationStyle;
        const c = hexToRgb(fillColor);
    
        s.fill.colour = "rgba("+c.r+","+c.g+","+c.b+","+fillTransparancy+")";
        setFillStyle(s.fill.colour);
        console.log("Change detected. "+fillStyle+" "+s.fill.colour);
        if ((fillStyle !== '') && (s.fill.colour !== fillStyle)){
          console.log("Requested made. "+s.fill.colour);
          sDispatch({type: "setstyle", payload: { style: s }});
        }
    }
  },[fillColor, fillTransparancy]);


  const rgbStringToHex = (rgb) => {
    rgb = rgb.replace('rgba(', '');
    rgb = rgb.replace(')', '');
    const rgb_parts = rgb.split(',');
    //console.log("rgb_parts: "+rgb_parts[0]+","+rgb_parts[1]+","+rgb_parts[2]);
    setFillTransparancy(rgb_parts[3]);
    return rgbToHex(parseInt(rgb_parts[0]),parseInt(rgb_parts[1]),parseInt(rgb_parts[2]));
  };

  const rgbToHex = (r, g, b) => {
    return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
    //return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
  };

  const componentToHex = (c) => {
    var hex = c.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
  };

  const hexToRgb = (hex) => {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function (m, r, g, b) {
      return r + r + g + g + b + b;
    });
  
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  }

  return (
    <div className={classes.paper} >

          <Box className={classes.container} display="flex" flexDirection="row" justifyContent="center">
          <RedRadio
            checked={fillColor === '#f44336'}
            onChange={handleFillStyleChange}
            value="#f44336"
            name="radio-button-demo"
            inputProps={{ 'aria-label': 'red' }}
          />
          <GreenRadio
            checked={fillColor === '#4caf50'}
            onChange={handleFillStyleChange}
            value="#4caf50"
            name="radio-button-demo"
            inputProps={{ 'aria-label': 'green' }}
          />
          <IndigoRadio
            checked={fillColor === '#3f51b5'}
            onChange={handleFillStyleChange}
            value="#3f51b5"
            name="radio-button-demo"
            inputProps={{ 'aria-label': 'blue' }}
          />
          <PurpleRadio
            checked={fillColor === '#673ab7'}
            onChange={handleFillStyleChange}
            value="#673ab7"
            name="radio-button-demo"
            inputProps={{ 'aria-label': 'purple' }}
          />
          <BlackRadio
            checked={fillColor === '#212121'}
            onChange={handleFillStyleChange}
            value="#212121"
            name="radio-button-demo"
            inputProps={{ 'aria-label': 'purple' }}
          />
          </Box>
          <Box className={classes.container} display="flex" flexDirection="row" justifyContent="center">
          <TextField id="fillTransparancy" label="Fill Transparancy" value={fillTransparancy} size="small" variant="outlined" InputProps={{classes: {input: classes.textItemFont}}} className={classes.textField} onChange={e => setFillTransparancy(e.target.value)} select >
              <MenuItem value={0}>No Fill</MenuItem>
              <MenuItem value={0.3}>Transparent</MenuItem>
              <MenuItem value={1}>Solid</MenuItem>
            </TextField>
          </Box>
    </div>
  );
}